import { useEffect, useState } from 'react';
import { Bot } from 'lucide-react';
import { cn } from '@/lib/utils';

interface Agent {
  id?: string;
  name?: string;
  logo?: string;
  description?: string;
}

export default function AgentIcon({
  agent,
  className,
}: {
  agent?: Agent | null;
  className?: string;
}) {
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    // Reset error state when agent or its logo changes
    setImageError(false);
  }, [agent?.logo, agent?.id]);

  const containerClass =
    className || 'w-8 h-8 rounded object-cover flex-shrink-0';

  if (!agent?.logo || imageError) {
    return (
      <div
        className={cn(
          containerClass,
          'bg-blue-100 flex items-center justify-center'
        )}
      >
        <Bot className="w-5 h-5 text-blue-600" />
      </div>
    );
  }

  return (
    <img
      src={agent.logo}
      alt={agent.name}
      className={containerClass}
      onError={() => setImageError(true)}
    />
  );
}
